import type { BestsellerProduct } from './types';

type BestsellerAvailabilityRecord = Partial<
  Pick<BestsellerProduct, 'inStock' | 'status' | 'stock'>
> & {
  in_stock?: unknown;
};

export function hasBestsellerProductAvailability(product: BestsellerAvailabilityRecord): boolean {
  return (
    product.status !== undefined ||
    product.stock !== undefined ||
    product.inStock !== undefined ||
    product.in_stock !== undefined
  );
}

export function isBestsellerProductUnavailable(product: BestsellerAvailabilityRecord): boolean {
  const status = product.status === undefined ? undefined : Number(product.status);
  const stock = product.stock === undefined ? undefined : Number(product.stock);

  return (
    status === 2 ||
    (Number.isFinite(stock) && Number(stock) <= 0) ||
    String(product.inStock ?? product.in_stock) === '2'
  );
}
